import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Article, SpinnerCard, ArticleLarge } from '../components/common/Layout'
import { Card, InputError } from '@foodsby/nutrient'
import { SimpleSpinner } from '../components/common/SimpleSpinner'
import { getAddressQueryStringParams } from '../redux/modules/selectors'
import { searchByLatLngNoFallbackApi } from '../redux/modules/locationSearch'
import { logException, normalizeErrorResponse } from '../util/errorUtils'
import SelectLocation, {
  RequestFoodsbyLink,
} from '../components/location-search/SelectLocation'
import scriptLoader from 'react-async-script-loader'
import { MAPS_SCRIPT_URL } from '../components/location-search/LocationSearchBox'
import { formatUrl } from '../util/formatUtils'
import { locationRoute } from '../routes/routes'
import { pushAnalyticsEvent } from '../util/gtmUtils'

const PageSelectKiosk = ({
  address: { street, city, state, zip, lat, lng } = {},
  isScriptLoaded,
  isScriptLoadSucceed,
}) => {
  const [kiosks, setKiosks] = useState()
  const [error, setError] = useState()
  useEffect(() => {
    pushAnalyticsEvent('Registration Flow', 'View Kiosks')
  }, [])

  useEffect(() => {
    // eslint-disable-next-line no-extra-semi
    ;(async () => {
      try {
        const results = await searchByLatLngNoFallbackApi({ lat, lng })
        setKiosks(
          results.map(location => ({
            ...location,
            deliveryLine1: null,
            lastLine: null,
          })),
        )
      } catch (ex) {
        logException(ex)
        setError(normalizeErrorResponse(ex))
      }
    })()
  }, [lat, lng])

  const goToLocation = id => {
    pushAnalyticsEvent('Registration Flow', 'Select Kiosk', undefined, id)
    window.location = formatUrl(locationRoute.path, {
      locationId: id,
    })
  }

  if (kiosks == null && error == null) {
    return (
      <Article>
        <Card>
          <SimpleSpinner />
        </Card>
      </Article>
    )
  } else {
    if (error != null) {
      return (
        <Article>
          <Card>
            <InputError>{error}</InputError>
          </Card>
        </Article>
      )
    }
    if (kiosks.length === 0) {
      return (
        <Article>
          <Card>There are no kiosks for this address.</Card>
        </Article>
      )
    } else {
      return (
        <ArticleLarge>
          <SpinnerCard spinnerActive={!isScriptLoaded}>
            {isScriptLoaded && isScriptLoadSucceed && (
              <SelectLocation
                address={`${street} - ${city}, ${state} ${zip}`}
                goToLocation={goToLocation}
                lat={lat}
                lng={lng}
                locations={kiosks}
                showError={error}
              />
            )}
          </SpinnerCard>
          <RequestFoodsbyLink />
        </ArticleLarge>
      )
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    address: getAddressQueryStringParams(state, ownProps),
  }
}

const mapDispatchToProps = {}
export default scriptLoader(MAPS_SCRIPT_URL)(
  connect(mapStateToProps, mapDispatchToProps)(PageSelectKiosk),
)
